// extracted by mini-css-extract-plugin
export var fileUpload = "_g9-1";
export var modalButton = "_g9-0";